/* pk floaters (16 Sep 2026): hide the Shopify Forms "10% off" side teaser on phones (it covered the menu and product previews).
   The sign-up popup itself still shows; only the rotated side tab is removed. Forms renders in an open shadow root, so a style is injected there. */
(function () {
  if (window.__pkFloaters) return; window.__pkFloaters = 1;
  var mq = window.matchMedia('(max-width: 749px)');
  function apply() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;
    var s = host.shadowRoot.getElementById('pk-teaser-off');
    if (!s) { s = document.createElement('style'); s.id = 'pk-teaser-off'; host.shadowRoot.appendChild(s); }
    /* 4 Oct: hiding it on phones cut signups from ~25/week to 1. Now a small pill bottom-right instead of the rotated side tab.
       It is hidden while the basket drawer is open, on /cart, and when the page is scroll-locked (CSS in theme.liquid hides the host). */
    s.textContent = mq.matches ? '#app-embed[data-current-step="tease"]{top:auto !important;bottom:20px !important;left:auto !important;right:12px !important;transform:none !important;rotate:0deg !important;padding:0 !important}#app-embed[data-current-step="tease"] *{rotate:0deg !important}#app-embed[data-current-step="tease"] [class*="_container_"]{transform:none !important}' : '';
    return true;
  }
  /* 4 Oct: never over the buy buttons on phones - hide the pill while Add to cart / Shop Pay / checkout buttons are on screen */
  var vis = 0;
  function hideIfButtons() {
    var host = document.querySelector('shopify-forms-embed'); if (!host) return;
    host.style.visibility = (mq.matches && vis > 0) ? 'hidden' : '';
  }
  function watchButtons() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { vis += e.isIntersecting ? 1 : (e.target.__pkSeen ? -1 : 0); e.target.__pkSeen = e.isIntersecting; }); vis = Math.max(0, vis); hideIfButtons(); });
    document.querySelectorAll('.product-form__submit, shopify-payment-button, .shopify-payment-button, [name="checkout"], .cart__checkout-button, sticky-add-to-cart, .sticky-atc').forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchButtons); else watchButtons();
  var n = 0, t = setInterval(function () { if (apply() || ++n > 40) clearInterval(t); hideIfButtons(); }, 750);
  if (mq.addEventListener) mq.addEventListener('change', apply);
})();
